import styled from 'styled-components'

const OptionTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export default OptionTitle